<template>
  <div
    :style="style"
    class="search-area-container"
    :class="{
      'search-area-container-opened': isOpen,
    }"
  >
    <div class="pull-right search-bar-container">
      <div class="pull-right button-wrapper">
        <button
          title="Search"
          class="hyp-details-search-button"
          @click="changeStyle"
        ></button>
      </div>
      <input
        class="hyp-search-ctrl-input-keyword"
        id="detailsKeyword"
        placeholder="Keyword"
        type="text"
        v-model="keywordSearch"
        :class="{ displayInline: isOpen, displayMonitor: enabled }"
        v-on:keyup.enter="submitDetails"
      />
      <i
        v-if="keywordSearch && isOpen"
        title="Clear search"
        class="fa fa-times search-details-close pull-right"
        @click="clearSearch"
      ></i>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import {
  MODULE_PREFIX_SEARCH,
  MODULE_PREFIX_HOME,
  MODULE_PREFIX_MONITOR,
} from "@/store";
import { getPrimaryTopics } from "@/services/events/topics.service";

const EMITTED_ACTIONS = {
  SUBMIT_SEARCH: "submit-search",
};

export default {
  name: "DetailsSearchBar",
  props: {
    type: {
      type: String,
    },
  },
  data() {
    return {
      keywordSearch: null,
      isOpen: false,
    };
  },
  mounted() {
    if (this.searchDetails) {
      this.isOpen = true;
      this.keywordSearch = this.searchDetails;
    }
  },
  computed: {
    ...mapGetters({
      searchDetails: MODULE_PREFIX_SEARCH + "searchDetails",
      detailsSidebar: MODULE_PREFIX_HOME + "detailsSidebar",
      enabled: MODULE_PREFIX_MONITOR + "enabled",
    }),
    style() {
      let topics = [];
      const PRIMARY_TOPICS = getPrimaryTopics();
      PRIMARY_TOPICS.map((topic) => {
        topics.push(topic.type);
      });
      let marginBottom = "30px";
      if (this.type === "hotspots") {
        marginBottom = "0";
      } else if (this.type === "news") {
        marginBottom = "58px";
      } else if (this.type === "social") {
        marginBottom = "53px";
      } else if (topics.indexOf(this.type) > -1) {
        marginBottom = "20px";
      } else if (this.type === "watch") {
        marginBottom = "10px";
      } else if (this.type === "stability") {
        marginBottom = "0";
      }
      return {
        "margin-bottom": marginBottom,
      };
    },
  },
  methods: {
    changeStyle() {
      this.isOpen = !this.isOpen;
    },
    async submitDetails() {
      this.$emit(EMITTED_ACTIONS.SUBMIT_SEARCH, this.keywordSearch);
    },
    clearSearch() {
      this.keywordSearch = null;
      this.submitDetails();
    },
  },
  beforeDestroy() {
    if (!this.enabled) {
      this.keywordSearch = null;
    }
  },
};
</script>
<style scoped>
.fa.fa-times.search-details-close.pull-right {
  color: white !important;
  margin-left: 5px;
  margin-top: 16px;
  margin-right: 30px;
  background-color: #343332 !important;
  position: relative !important;
  cursor: pointer;
}

.hyp-search-ctrl-input-keyword {
  display: none;
}
.hyp-search-ctrl-input-keyword.displayInline {
  border: none;
  outline: none;
  color: white !important;
  background-color: #343332 !important;
  height: 33px;
  width: 95%;
  margin-left: 7px;
  margin-top: 7px;
  padding: 10px;
  position: absolute;
  display: inline;
  border-radius: 25px;
  z-index: 0 !important;
}
.hyp-search-ctrl-input-keyword.displayInline.displayMonitor {
  border: none;
  outline: none;
  color: white !important;
  background-color: #343332 !important;
  height: 33px;
  width: 93%;
  margin-top: 7px;
  padding: 10px;
  position: absolute;
  display: inline;
  border-radius: 25px;
  right: 0 !important;
  margin-right: 20px;
}
.hyp-details-search-button {
  background-image: url("../../../assets/images/icons/search.png");
  position: absolute;
  background-color: white !important;
  background-position: center;
  border-radius: 25px;
  height: 32px;
  width: 32px;
  margin-right: 9px;
  margin-top: 7px;
  z-index: 1 !important;
  position: relative;
  outline: none;
}
.pull-right.hyp-details-search-button.adjustWidth {
  position: absolute;
  padding-right: 5px;
  border-radius: 25px;
  height: 34px;
  margin-right: 7px;
  width: 450px !important;
  background-color: #343332 !important;
  color: white;
  z-index: 1;
}
.search-area-container {
  position: absolute !important;
  bottom: 0 !important;
  background-color: transparent !important;
  height: 80px !important;
  right: 0;
}
.search-area-container-opened {
  background-color: #191a1a !important;
  width: 100%;
}
.pull-right.search-bar-container {
  height: 34px;
  width: 100%;
}
</style>
